import type * as protocol from './protocol';

/**
 * Returns the message ID from a DataSync message.
 */
export function getMessageId(message: protocol.IMessage): number {
    if ('promptInit' in message && message.promptInit) {
        return message.promptInit.id;
    }

    if ('init' in message && message.init) {
        return message.init.id;
    }

    if ('update' in message && message.update) {
        return message.update.id;
    }

    if ('updatePresence' in message && message.updatePresence) {
        return message.updatePresence.id;
    }

    if ('broadcastOperation' in message && message.broadcastOperation) {
        return message.broadcastOperation.id;
    }

    if ('broadcastPresences' in message && message.broadcastPresences) {
        return message.broadcastPresences.id;
    }

    if ('ack' in message && message.ack) {
        return message.ack.id;
    }

    if ('rpcRequest' in message && message.rpcRequest) {
        return message.rpcRequest.id;
    }

    if ('rpcReply' in message && message.rpcReply) {
        return message.rpcReply.id;
    }

    throw new Error(`Unknown message type: ${JSON.stringify(message)}`);
}
